import { c as _c } from "react-compiler-runtime";
import React from 'react';
import useI18nString from '@nike/shop-apis/assets/i18n/dotcom-cart/use-query';
import WishlistItemAddedModalActions from './WishlistItemAddedModalActions';
import WishlistItemAddedModalProductSize from './WishlistItemAddedModalProductSize';
import WishlistItemPrice from './WishlistItemPrice';
import ProductAddedModal from "../base/ProductAddedModal";
var WishlistItemAddedModal = function WishlistItemAddedModal() {
  var $ = _c(4);
  var t0;
  if ($[0] === Symbol["for"]("react.memo_cache_sentinel")) {
    t0 = {
      stringKey: "addToCart.modal.header.addedToFavorites",
      primaryValue: "Added to Favorites",
      description: "Add to cart modal header when adding item to favorites"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  var addedToFavoritesTitle = useI18nString(t0);
  var t1;
  if ($[1] === Symbol["for"]("react.memo_cache_sentinel")) {
    t1 = /*#__PURE__*/React.createElement(WishlistItemAddedModalActions, null);
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  var t2;
  if ($[2] !== addedToFavoritesTitle) {
    t2 = /*#__PURE__*/React.createElement(ProductAddedModal, {
      title: addedToFavoritesTitle,
      ActionsSlot: t1,
      ProductSizeComponent: WishlistItemAddedModalProductSize,
      PriceComponent: WishlistItemPrice,
      shouldScrollToTopOnOpen: true
    });
    $[2] = addedToFavoritesTitle;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default WishlistItemAddedModal;